import { useQuery } from 'react-query';
import { pageContextApi, type PageContextResponse } from '../services/pageContextApi';

/**
 * Fetches page-level context (related chronology events) for a specific document page.
 * Only fires when both documentId and pageNumber are provided.
 */
export function usePageContext(documentId: string | undefined, pageNumber: number | undefined) {
  return useQuery<PageContextResponse>(
    ['pageContext', documentId, pageNumber],
    () => pageContextApi.getPageContext(documentId!, pageNumber!),
    {
      enabled: !!documentId && pageNumber != null && pageNumber > 0,
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  );
}
